export default __webpack_public_path__ + "static/media/camera.b50348a3.svg";